
$(document).ready(function(e){
	if ($(document).find('.field.checkbox')){
		$(document).find('.field.checkbox').each(function(){

			var dom = $(this);
			var input = dom.find('input.checkbox');

			if (dom.hasClass('checkbox--button') && input.attr('href')){
				dom.on('click', function(e){

					if (input.is(':checked')){
						input.prop('checked', false);
						input.val(0);

					// When we're not checked, open the link in a new window
					} else {
						input.prop('checked', true);
						input.val(1);
						window.open(input.attr('href'));
					}

					e.preventDefault();
					return false;
				});
			}
		});
	}
});